import { render, staticRenderFns } from "./FileManager.vue?vue&type=template&id=52712652&scoped=true&"
import script from "./FileManager.vue?vue&type=script&lang=js&"
export * from "./FileManager.vue?vue&type=script&lang=js&"
import style0 from "./FileManager.vue?vue&type=style&index=0&id=52712652&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52712652",
  null
  
)

export default component.exports